var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "radio-button-group", attrs: { role: "group" } },
    _vm._l(_vm.options, function(option) {
      return _c(
        "div",
        { key: option.value, staticClass: "radio-button-group-option" },
        [
          _c("input", {
            attrs: {
              id: option.value,
              tabindex: "-1",
              type: "radio",
              name: option.name,
              disabled: !option.isAvailable
            },
            domProps: {
              value: option.value,
              checked: option.value === _vm.selected
            },
            on: {
              click: function($event) {
                return _vm.onClick(option.label)
              }
            }
          }),
          _vm._v(" "),
          _c(
            "label",
            {
              attrs: {
                disabled: !option.isAvailable,
                tabindex: "0",
                for: option.value
              }
            },
            [
              _vm._v(
                "\n      " + _vm._s(_vm.truncateText(option.label)) + "\n    "
              )
            ]
          )
        ]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }